var jade = require("/build/customer-ui/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

jade_mixins["social"] = jade_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<div class=\"social-widgets\"><div class=\"social-share-button facebook-share\"></div><div class=\"social-share-button twitter-share\"></div></div>");
};
jade_mixins["thumbnails"] = jade_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<div ng-if=\"product.product.backView === &quot;SHOW&quot;\" class=\"thumbnail-links row\"><div class=\"col-sm-3 col-sm-offset-3 col-xs-4 col-xs-offset-2\"><a ng-class=\"{ active: storeRef.view == &quot;front&quot;}\" ng-click=\"changeView(&quot;front&quot;)\" class=\"thumbnail-link\"><img ng-src=\"{{product.assets.front_thumbnail | protocolRelative}}\" alt=\"\" class=\"hidden-xs\"><div class=\"text-center\">Front</div></a></div><div class=\"col-sm-3 col-xs-4\"><a ng-class=\"{ active: storeRef.view == &quot;back&quot;}\" ng-click=\"changeView(&quot;back&quot;)\" class=\"thumbnail-link\"><img ng-src=\"{{product.assets.back_thumbnail | protocolRelative}}\" alt=\"\" class=\"hidden-xs\"><div class=\"text-center\">Back</div></a></div></div>");
};
jade_mixins["flair"] = jade_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<div ng-if=\"storeRef.campaign.flair.seal_url &amp;&amp; storeRef.campaign.flair.seal_url != &quot;&quot;\" class=\"flair flair-seal\"><img ng-src=\"{{storeRef.campaign.flair.seal_url}}\" alt=\"campaign seal flair image\"></div>");
};
buf.push("<div><product-zoom ng-if=\"!colorChangingMug\"><div class=\"zoom-display\"></div><product-carousel view=\"storeRef.view\" product=\"product\" ng-if=\"product.product.backView === &quot;SHOW&quot;\"></product-carousel>");
jade_mixins["flair"]();
jade_mixins["thumbnails"]();
buf.push("<div ng-if=\"product.product.backView != &quot;SHOW&quot;\"><img ng-src=\"{{product.assets.front_display_url | protocolRelative}}\" alt=\"Product Image\" class=\"zoom standalone-slide\"></div>");
jade_mixins["social"]();
buf.push("</product-zoom><product-color-transition ng-if=\"colorChangingMug\" product=\"product\" view=\"storeRef.view\">");
jade_mixins["flair"]();
jade_mixins["thumbnails"]();
jade_mixins["social"]();
buf.push("</product-color-transition></div>");;return buf.join("");
}


// WEBPACK FOOTER //
// ./source/client/pages/store/product-display/product-display.jade